import { defaultDictionaryValueMissing } from '../repository';

export type ActionKey = 'Close' | 'Open' | 'ToggleMenu' | 'ToTop' | 'PlayVideo' | 'SkipToMain' | 'ReadAloud';

export const getDefaultActionValue = (key: ActionKey): string => {
	switch (key) {
		case 'Close':
			return 'Tilbage';
		case 'Open':
			return 'Åben';
		case 'ToggleMenu':
			return 'Åben/Luk menu';
		case 'ToTop':
			return 'Til toppen';
		case 'PlayVideo':
			return 'Afspil video';
		case 'SkipToMain':
			return 'Spring til indhold';
		case 'ReadAloud':
			return 'Læs op';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
